<template>
  <div class="address-fields">
    <div class="form-group">
      <label for="name">
        CEP
        <span v-if="required('postal_code')">*</span>
      </label>
      <input
        name="cep"
        v-model="address.postal_code"
        v-mask="'#####-###'"
        v-on:change="verifyPostalCode()"
        type="text"
        class="form-control"
        v-bind:class="{'input-error': showError('postal_code')}"
        v-bind:disabled="this.role != 'admin'"
      />
      <div class="general-error" v-if="showError('postal_code')">O campo CEP é necessário</div>
      <div class="general-error" v-if="cepNotFound">CEP não encontrado. Preencha o endereço manualmente abaixo.</div>
    </div>

    <div class="form-group">
      <label for="name">
        Logradouro
        <span v-if="required('street')">*</span>
      </label>
      <input
        name="cep"
        v-model="address.street"
        type="text"
        class="form-control"
        v-bind:class="{'input-error': showError('street')}"
        
      />
      <div class="general-error" v-if="showError('street')">O campo Rua é necessário</div>
    </div>

    <div class="form-group">
      <label for="name">
        Bairro
        <span v-if="required('neighborhood')">*</span>
      </label>
      <input
        name="cep"
        v-model="address.neighborhood"
        type="text"
        class="form-control"
        v-bind:class="{'input-error': showError('neighborhood')}"
        
      />
      <div class="general-error" v-if="showError('neighborhood')">O campo Bairro é necessário</div>
    </div>

    <div class="form-group">
      <label for="name">
        Número
        <span v-if="required('number')">*</span>
      </label>
      <input
        name="cep"
        v-model="address.number"
        type="text"
        class="form-control"
        v-bind:class="{'input-error': showError('number')}"
         v-bind:disabled="this.role != 'admin'"
      />
      <div class="general-error" v-if="showError('number')">O campo Número é necessário</div>
    </div>

    <div class="form-group">
      <label for="name">
        Cidade
        <span v-if="required('city')">*</span>
      </label>
      <input
        name="cep"
        v-model="address.city"
        type="text"
        class="form-control"
        v-bind:class="{'input-error': showError('city')}"
      />
      <div class="general-error" v-if="showError('city')">O campo Cidade é necessário</div>
    </div>

    <div class="form-group">
      <label for="name">
        Estado
        <span v-if="required('state')">*</span>
      </label>
      <input
        name="cep"
        v-model="address.state"
        type="text"
        class="form-control"
        v-bind:class="{'input-error': showError('state')}"
      />
      <div class="general-error" v-if="showError('state')">O campo Estado é necessário</div>
    </div>

    <div class="form-group">
      <label for="name">Complemento</label>
      <input name="cep" v-model="address.complement" type="text" class="form-control"  v-bind:disabled="this.role != 'admin'" />
    </div>
  </div>
</template>
<script>
import axios from "axios";
import { required } from "vuelidate/lib/validators";

export default {
  name: "address-fields",
  data() {
    return {
      address: {
        postal_code: "",
        street: "",
        neighborhood: "",
        city: "",
        state: "",
        number: null,
        complement: "",
      },
       role: localStorage.getItem("auth.role"),
       cepNotFound: false,
    };
  },
  props: {
    data: {},
    submited: Boolean,
    readonly: {
      type: Boolean,
      default: false,
    }
  },
  mounted: function() {
    if (this.data) {
      this.address = this.data;
    }
  },
  validations: {
    address: {
      postal_code: {
        required
      },
      street: {
        required
      },
      neighborhood: {
        required
      },
      number: {
        required
      },
      city: {
        required
      },
      state: {
        required
      }
    }
  },
  methods: {
    verifyPostalCode: function() {
      const that = this;
      this.cepNotFound = false;
      let tipCep = this.address.postal_code.replace("-", "");
      axios
        .get("https://viacep.com.br/ws/" + tipCep + "/json/")
        .then(({ data }) => {
          if (data.erro) {
            that.cepNotFound = true;
            return;
          }
          that.updateAddress(data);
        })
        .catch(function() {
          that.cepNotFound = true;
        });
    },
    updateAddress: function(data) {


      this.$set(this.address, "street", data.logradouro);
      this.$set(this.address, "neighborhood", data.bairro);
      this.$set(this.address, "city", data.localidade);
      this.$set(this.address, "state", data.uf);
    },

    showError: function(attribute) {
      return this.$v.address[attribute].$invalid && this.submited;
    },
    required: function(attribute) {
      return this.$v.address[attribute].$params.required;
    }
  }
};
</script>
